module.exports = __webpack_public_path__ + "static/media/mevuelo-blanco.3279e95b.svg";